import React from 'react';
import { Checkbox, Form, Header } from 'semantic-ui-react';
import { publicModelIDsV113 } from './publicModelNamingV113';
import './publicModelIDsV113.css';

export default function PublicModelIDsV113({ config, onChange, disabled, t }) {
  const policy = publicModelIDsV113(config);
  const label = (key) => t(`channel.edit.public_ids_v113.${key}`);
  return (
    <section className='channel-public-ids-v113' aria-label={label('title')}>
      <Header as='h4'>{label('title')}</Header>
      {['strip_vendor_prefix', 'strip_free_suffix'].map((name) => (
        <Form.Field key={name}>
          <Checkbox
            toggle
            name={`public_model_ids_v113.${name}`}
            label={{
              children: <span className='channel-public-ids-v113__label'>{label(name)}</span>,
            }}
            checked={policy[name]}
            disabled={disabled}
            onChange={(event, { checked }) =>
              onChange(event, {
                name: 'public_model_ids_v113',
                value: { ...policy, [name]: checked },
              })
            }
          />
        </Form.Field>
      ))}
    </section>
  );
}
